import baseRequest from './baseRequest';

const baseUrl = 'api/auto/loans';

export const updateAutoLoanSubType = async (loanId: string, subTypeParams: AutoLoanSubType): Promise<void> => {
  await baseRequest.put(`${baseUrl}/${loanId}/sub-type`, subTypeParams);
};
